// extracted by mini-css-extract-plugin
export default {"root":"IconCollection_root__PDOKJ"};